import { render, staticRenderFns } from "./InvestmentCharts.vue?vue&type=template&id=df785fe6&scoped=true"
import script from "./InvestmentCharts.vue?vue&type=script&lang=js"
export * from "./InvestmentCharts.vue?vue&type=script&lang=js"
import style0 from "./InvestmentCharts.vue?vue&type=style&index=0&id=df785fe6&prod&lang=css"
import style1 from "./InvestmentCharts.vue?vue&type=style&index=1&id=df785fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df785fe6",
  null
  
)

export default component.exports